import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputRightElement,
  InputLeftElement,
  InputGroup
} from '@chakra-ui/core'
import { InputProps } from '@chakra-ui/core/dist/Input'
import { useField } from 'formik'
import * as React from 'react'
import { Text } from '../../../typography'
import { LabelProps } from '../styles'

export type ConnectedFormGroupProps = LabelProps &
  InputProps & {
    label?: string
    name: string
    prefix?: string
    suffix?: string
  }

const ConnectedFormGroup: React.FC<ConnectedFormGroupProps> = ({
  label,
  prefix,
  suffix,
  ...rest
}) => {
  const [field, meta] = useField(rest.name)
  return (
    <Flex flexDirection="column" width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
      <FormControl>
        {label && (
          <FormLabel fontSize="sm" fontWeight="normal" htmlFor={field.name}>
            {label}
          </FormLabel>
        )}
        <InputGroup>
          {prefix && <InputLeftElement>{prefix}</InputLeftElement>}
          <Input focusBorderColor="accent.500" fontSize="xs" {...field} id={field.name} {...rest} />
          {suffix && <InputRightElement>{suffix}</InputRightElement>}
        </InputGroup>
        {meta.touched && meta.error ? (
          <Text color="red.500" fontSize="xs">
            {meta.error}
          </Text>
        ) : null}
      </FormControl>
    </Flex>
  )
}

export default ConnectedFormGroup

ConnectedFormGroup.defaultProps = {
  mb: 2,
  type: 'text',
  variant: 'filled'
}
